import { render, staticRenderFns } from "./cameras.vue?vue&type=template&id=10b054b7&scoped=true"
import script from "./cameras.vue?vue&type=script&lang=js"
export * from "./cameras.vue?vue&type=script&lang=js"
import style0 from "./cameras.vue?vue&type=style&index=0&id=10b054b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b054b7",
  null
  
)

export default component.exports